import { useCreate } from '@refinedev/core';

export const useAddTestValuationUpdate = () => {
  const { mutateAsync, error, isLoading } = useCreate();

  const addTestValuationUpdate = async () => {
    await mutateAsync({
      resource: 'admin/test-unprocessed-valuation-updates',
      values: {},
    });
  };

  return {
    addTestValuationUpdate,
    isLoading,
    error,
  };
};
